// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-details-list-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.game-details-list-section .game-details-list-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.game-details-list-section .game-details-list-wrap .list-text {
  list-style-type: none;
}
.game-details-list-section .game-details-list-wrap .list-text .list-item {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
}
.game-details-list-section .game-details-list-wrap .list-text .list-item:not(:last-child) {
  border-bottom: 1px solid var(--quickSilver-1000);
}
.game-details-list-section .game-details-list-wrap .list-text .list-item.label-text {
  font-weight: 700;
}
.game-details-list-section .game-details-list-wrap .list-text .list-item.text {
  font-weight: 400;
}
.game-details-list-section .game-details-list-wrap .list-text .list-item .flag-box {
  display: flex;
  gap: 0.375rem;
}
.game-details-list-section .game-details-list-wrap .list-text .list-item .flag-box img {
  width: 100%;
  max-width: 1.625rem;
  height: auto;
}
.game-details-list-section .game-details-list-wrap .btn-box {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}
@media screen and (max-width: 991.98px) {
  .game-details-list-section {
    padding: 2.5rem 0;
  }
  .game-details-list-section .game-details-list-wrap .list-text .list-item {
    font-size: 1rem;
    padding: 0.75rem;
  }
  .game-details-list-section .game-details-list-wrap .list-text .list-item .flag-box img {
    max-width: 1.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .game-details-list-section {
    padding: 2rem 0;
  }
  .game-details-list-section .game-details-list-wrap .list-text .list-item {
    font-size: 0.875rem;
    padding: 0.5rem;
  }
  .game-details-list-section .game-details-list-wrap .list-text .list-item .flag-box img {
    max-width: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GameDetailsListSection/GameDetailsListStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,qBAAA;AACN;AACM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AACR;AACQ;EACE,gDAAA;AACV;AAEQ;EACE,gBAAA;AAAV;AAGQ;EACE,gBAAA;AADV;AAIQ;EACE,aAAA;EACA,aAAA;AAFV;AAIU;EACE,WAAA;EACA,mBAAA;EACA,YAAA;AAFZ;AAQI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AANN;AAUE;EAvDF;IAwDI,iBAAA;EAPF;EAWM;IACE,eAAA;IACA,gBAAA;EATR;EAYU;IACE,iBAAA;EAVZ;AACF;AAiBE;EA1EF;IA2EI,eAAA;EAdF;EAkBM;IACE,mBAAA;IACA,eAAA;EAhBR;EAmBU;IACE,eAAA;EAjBZ;AACF","sourcesContent":[".game-details-list-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .game-details-list-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;    \n\n    .list-text {\n      list-style-type: none;\n\n      .list-item {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n        display: flex;\n        justify-content: space-between;\n        gap: 1rem;\n        padding: 1rem;\n\n        &:not(:last-child) {\n          border-bottom: 1px solid var(--quickSilver-1000);\n        }\n\n        &.label-text {\n          font-weight: 700;\n        }\n\n        &.text {\n          font-weight: 400;\n        }\n\n        .flag-box {\n          display: flex;\n          gap: 0.375rem;\n\n          img {\n            width: 100%;\n            max-width: 1.625rem;\n            height: auto;\n          }\n        }\n      }\n    }\n\n    .btn-box {\n      display: flex;\n      justify-content: center;\n      gap: 1rem;\n      margin-top: 2rem;\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n    \n    .game-details-list-wrap {\n      .list-text {\n        .list-item {\n          font-size: 1rem;\n          padding: 0.75rem;\n\n          .flag-box {  \n            img {\n              max-width: 1.5rem;\n            }\n          }\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n    \n    .game-details-list-wrap {\n      .list-text {\n        .list-item {\n          font-size: 0.875rem;\n          padding: 0.5rem;\n\n          .flag-box {  \n            img {\n              max-width: 1rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
